import { z } from 'zod';

export const DepartmentIncomeTypeSchema = z.object({
  _id: z.string().optional(),
  departmentId: z.string().min(1, 'Department ID is required'),
  typeId: z.string().min(1, 'Type ID is required'),
  createdAt: z.date().optional(),
  updatedAt: z.date().optional(),
});

export type DepartmentIncomeType = z.infer<typeof DepartmentIncomeTypeSchema>;

export const SetDepartmentTypesSchema = z.object({
  typeIds: z.array(z.string()),
});

export type SetDepartmentTypes = z.infer<typeof SetDepartmentTypesSchema>;
